/*!
 * devextreme-angular
 * Version: 26.1.6
 * Build date: Fri Oct 16 2026
 *
 * Copyright (c) 2012 - 2026 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/DevExtreme
 */

/* tslint:disable:max-line-length */


import {
    Component,
    OnInit,
    OnDestroy,
    NgModule,
    Host,
    SkipSelf,
    Input
} from '@angular/core';




import type { PagerPageSize } from 'devextreme/common/grids';
import type { Mode, DisplayMode } from 'devextreme/common';

import {
    DxIntegrationModule,
    NestedOptionHost,
} from 'devextreme-angular/core';
import { NestedOption } from 'devextreme-angular/core';


@Component({
    selector: 'dxo-tree-list-pager',
    template: '',
    styles: [''],
    imports: [ DxIntegrationModule ],
    providers: [NestedOptionHost]
})
export class DxoTreeListPagerComponent extends NestedOption implements OnDestroy, OnInit  {
    @Input()
    get allowedPageSizes(): Array<number | PagerPageSize> | Mode {
        return this._getOption('allowedPageSizes');
    }
    set allowedPageSizes(value: Array<number | PagerPageSize> | Mode) {
        this._setOption('allowedPageSizes', value);
    }

    @Input()
    get displayMode(): DisplayMode {
        return this._getOption('displayMode');
    }
    set displayMode(value: DisplayMode) {
        this._setOption('displayMode', value);
    }

    @Input()
    get infoText(): string {
        return this._getOption('infoText');
    }
    set infoText(value: string) {
        this._setOption('infoText', value);
    }

    @Input()
    get label(): string {
        return this._getOption('label');
    }
    set label(value: string) {
        this._setOption('label', value);
    }

    @Input()
    get showInfo(): boolean {
        return this._getOption('showInfo');
    }
    set showInfo(value: boolean) {
        this._setOption('showInfo', value);
    }

    @Input()
    get showNavigationButtons(): boolean {
        return this._getOption('showNavigationButtons');
    }
    set showNavigationButtons(value: boolean) {
        this._setOption('showNavigationButtons', value);
    }

    @Input()
    get showPageSizeSelector(): boolean | Mode {
        return this._getOption('showPageSizeSelector');
    }
    set showPageSizeSelector(value: boolean | Mode) {
        this._setOption('showPageSizeSelector', value);
    }

    @Input()
    get visible(): boolean | Mode {
        return this._getOption('visible');
    }
    set visible(value: boolean | Mode) {
        this._setOption('visible', value);
    }


    protected get _optionPath() {
        return 'pager';
    }


    constructor(@SkipSelf() @Host() parentOptionHost: NestedOptionHost,
            @Host() optionHost: NestedOptionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }


    ngOnInit() {
        this._addRecreatedComponent();
    }

    ngOnDestroy() {
        this._addRemovedOption(this._getOptionPath());
    }


}

@NgModule({
  imports: [
    DxoTreeListPagerComponent
  ],
  exports: [
    DxoTreeListPagerComponent
  ],
})
export class DxoTreeListPagerModule { }
